import ModalDialog from 'components/ModalDialog';

import PCFindingDetailModalContent from './PCFindingDetailModalContent';

type Props = {
  id: number;
  onClose: () => void;
};

const PCFindingDetailModal = ({ id, onClose }: Props) => {
  return (
    <ModalDialog
      size="lg"
      title="Detail View"
      subTitle={<p className="d-flex align-items-center"></p>}
      childComponent={<PCFindingDetailModalContent id={id} />}
      customFooter={<></>}
      onClose={onClose}
    />
  );
};

export default PCFindingDetailModal;
